import { FC } from "react";
import { useTranslation } from "react-i18next";

import { SVG_MUI } from "@ryde/assets";
import { FramerTooltip } from "@ryde/controls";
import { useBulkReportActions } from "@ryde/redux";
import { TOOLTIP_DELAY_BUTTONS } from "@ryde/shared";

export const ReportTableHeadBulk: FC = () => {
  const { handleBulkActionClick, isBulkActionButtonShown } =
    useBulkReportActions();

  const { t } = useTranslation();

  return (
    isBulkActionButtonShown && (
      <div className="report-bulk-button">
        <FramerTooltip
          content={t("general.BULK_ACTIONS")}
          mouseEnterDelay={TOOLTIP_DELAY_BUTTONS}
        >
          <SVG_MUI.ReportsBulkEditSVG
            className="pointer"
            onClick={handleBulkActionClick}
          />
        </FramerTooltip>
      </div>
    )
  );
};
